export default __webpack_public_path__ + "static/media/ThaiSansNeue-Black.5e9fae4a.ttf";